import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const Success = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        const sessionId = searchParams.get('session_id');
        console.log('Pagamento concluído:', sessionId);
        
        // Redirecionar para dashboard após 3 segundos
        setTimeout(() => {
            navigate('/dashboard');
        }, 3000);
    }, [searchParams, navigate]);

    return (
        <div className="success-page">
            <div className="success-container">
                <div className="success-icon">✅</div>
                <h1>Pagamento realizado com sucesso!</h1>
                <p>Sua assinatura foi ativada. Redirecionando para o dashboard...</p>
                <button onClick={() => navigate('/dashboard')}>
                    Ir para Dashboard
                </button>
            </div>
        </div>
    );
};

export default Success;